import { render, staticRenderFns } from "./TotalAllCharts.vue?vue&type=template&id=2008dcd9&"
import script from "./TotalAllCharts.vue?vue&type=script&lang=js&"
export * from "./TotalAllCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports